import { useSafeTranslation } from 'shared/i18n';
import { capitalizeName } from 'shared/util/capitalizeName';

type TitleProps = {
  name: {
    firstName: string;
    lastName: string;
  };
};

export const Title = ({ name }: TitleProps) => {
  const { t } = useSafeTranslation();

  return (
    <h1 className="p-h1 mt16">
      {t('components.account.title', 'Do you want to continue as')}{' '}
      <span className="tc-primary-500">{capitalizeName(name)}</span>?
    </h1>
  );
};
